import { PageHero } from "@/components/PageHero";
import { usePageMeta } from "@/hooks/usePageMeta";

function DraftBanner() {
  return (
    <div className="rounded-lg border border-gold/40 bg-gold/10 px-5 py-4 text-sm text-navy">
      <strong>Draft for owner review.</strong> This is placeholder language provided for review before
      launch. It is not legal advice. Please have it reviewed and finalized before publishing.
    </div>
  );
}

export default function Terms() {
  usePageMeta("Terms of Use", "Terms of Use for Lord Almighty (draft for review).");
  return (
    <div>
      <PageHero eyebrow="Legal" title="Terms of Use" />
      <section className="mx-auto max-w-3xl px-5 lg:px-8 py-16 space-y-6 text-muted-foreground leading-relaxed">
        <DraftBanner />
        <p>By using this website, you agree to these terms. Please read them carefully.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Use of the site</h2>
        <p>This site is provided for informational purposes and to facilitate inquiries and business
          directory submissions. You agree to provide accurate information and to use the site lawfully.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Business directory</h2>
        <p>Directory listings are submitted by business owners and reviewed before publication.
          Statements about faith and community involvement are provided by owners. Inclusion in the
          directory is not a guarantee of services or an endorsement of every business practice. We do
          not display "verified" or "vetted" badges without a defined review process.</p>
        <h2 className="font-display text-2xl text-navy pt-2">No guarantees</h2>
        <p>Submitting an inquiry does not guarantee funding, representation, placement, a property
          purchase, or any specific outcome.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Intellectual property</h2>
        <p>Content and marks on this site are the property of their respective owners and may not be
          used without permission.</p>
        <h2 className="font-display text-2xl text-navy pt-2">Changes</h2>
        <p>We may update these terms from time to time. Continued use of the site constitutes acceptance
          of the current terms.</p>
      </section>
    </div>
  );
}
